import { IRest } from './rest.interface';
import { Topic, PlanTopic } from './topic';
import { EnumPlanStatusType } from './enums/plan-status-type.enum';

export class Subject implements IRest {
    className = 'Disciplina';

    id!: number;
    name!: string;
    topics!: Array<Topic>;
    announcementInitials!: string; //Uso Interno
    weight!: number; //Uso Interno

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            name: this.name,
            topics: this.topics
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.name = data['name'] || '';
            this.topics = (data['topics'] || []).map((t: any) => new Topic(t));
        }
        return this;
    }

}

export class JobSubject implements IRest {
    className = 'Relacionamento entre Job e Disciplina';

    id!: number;
    jobId!: number;
    subjectId!: number;
    subject!: Subject;
    alias!: string;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            jobId: this.jobId,
            subjectId: this.subjectId,
            subject: this.subject.Serialize(),
            alias: this.alias
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.jobId = data['jobId'] || 0;
            this.subjectId = data['subjectId'] || 0;
            this.subject = new Subject(data['subject'] || {});
            this.alias = data['alias'] || '';
        }
        return this;
    }

}

export class PlanSubjectStats implements IRest {
    className = 'Estastísticas da Disciplina no Relacionamento com o Plano';

    subjectId!: number;
    questionsHit!: number;
    questionsMiss!: number;
    questionsPercentage!: number; //Uso Interno
    duration!: number;
    durationString!: string; //Uso Interno
    lastStudyId!: number;
    lastStudyDate!: Date;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            subjectId: this.subjectId,
            questionsHit: this.questionsHit,
            questionsMiss: this.questionsMiss,
            duration: this.duration,
            lastStudyId: this.lastStudyId,
            lastStudyDate: this.lastStudyDate.toISOString()
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.subjectId = data['subjectId'] || 0;
            this.questionsHit = data['questionsHit'] || 0;
            this.questionsMiss = data['questionsMiss'] || 0;
            this.questionsPercentage = Math.round(this.questionsHit / ((this.questionsHit + this.questionsMiss) || 1) * 100);
            this.duration = data['duration'] || 0;
            this.durationString = GetTimeStringFormat(this.duration, true, true);
            this.lastStudyId = data['lastStudyId'] || 0;
            this.lastStudyDate = data['lastStudyDate'] ? new Date(data['lastStudyDate']) : new Date(2000, 0);
        }
        return this;
    }

}

export class PlanSubject implements IRest {
    className = 'Relacionamento entre Plano e Disciplina';

    id!: number;
    name!: string;
    alias?: string;
    color!: string;
    archived!: boolean;
    jobIds!: Array<number>;
    topics!: Array<PlanTopic>;
    topicIds!: Array<number>;
    jobTopicsCount!: number;
    customTopicsCount!: number;
    topicsCount!: number;
    topicsStudied!: number;
    stats!: PlanSubjectStats;
    statusFinished!: number; //Uso Interno
    announcementInitials?: string; //Uso Interno

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            name: this.name,
            alias: this.alias,
            color: this.color,
            archived: this.archived,
            jobIds: this.jobIds,
            topics: this.topics.map(pt => pt.Serialize()),
            topicIds: this.topicIds,
            jobTopicsCount: this.jobTopicsCount,
            customTopicsCount: this.customTopicsCount,
            topicsCount: this.topicsCount,
            topicsStudied: this.topicsStudied,
            stats: this.stats.Serialize()
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.name = data['name'] || '';
            this.alias = data['alias'] || '';
            this.color = data['color'] || '#2DCDAA';
            this.archived = data['archived'] || false;
            this.jobIds = data['jobIds'] || [];
            if (!this.jobIds.length && data['jobId']) this.jobIds.push(data['jobId']);
            this.topics = (data['topics'] || []).map((pt: any) => new PlanTopic(pt));
            this.topicIds = data['topicIds'] || [];
            this.jobTopicsCount = data['jobTopicsCount'] || 0;
            this.customTopicsCount = data['customTopicsCount'] || 0;
            this.topicsCount = data['topicsCount'] || 0;
            this.topicsStudied = data['topicsStudied'] || 0;
            this.stats = new PlanSubjectStats(data['stats'] || {});
            this.statusFinished = Math.round((this.topicsStudied / (this.topicsCount || 1)) * 100);
        }
        return this;
    }

}

//Obter o Formato de Hora a Partir do Total de Segundos
function GetTimeStringFormat(totalSeconds: number, hourDigit?: boolean, string?: boolean): string {
    if (!totalSeconds) return '-';

    const hours = (Math.floor(totalSeconds / 3600)).toString();
    const minutes = (Math.floor((totalSeconds % 3600) / 60)).toString().padStart(2, '0');
    const seconds = (totalSeconds % 60).toString();

    if (string) return `${hours}h${minutes}min`;

    if (hourDigit)
        return (hours.padStart(2, '0') + minutes + seconds.padStart(2, '0'));
    else
        return (minutes + seconds.padStart(2, '0'));
}